import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryRoomAccommodation extends FDictionary {
  dictionary = 'roomAccomodation';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
